import React, { useContext, useEffect, useState } from "react";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Typography,
  Stack,
  Button,
  Avatar,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Images } from "./../../assets/common";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import Loader from "./../../components/Loader";
import DropMenu from "./../../components/DropMenu";
import OutsideClickHandler from "react-outside-click-handler";

import {
  convertHMS,
  HMS,
  fullName,
  getErrorString,
  getUserDetail,
  isOwnerId,
  isOwner,
  getUserId,
  kFormatter,
  copyToClipboard,
  dynamicLink,
  onShare,
  putRecors,
} from "./../../constants/function";
import { useParams, useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import NoData from "../../components/Nodata";
import { useSelector, useDispatch } from "react-redux";
import { addSongAction, addSongsAction } from "./../../action/songs";
import AddMusicToPlaylist from "./../../components/AddMusicToPlaylist";
import ConfirmMusicNft from "../../components/ConfirmMusicNft";
import SuccessPopup from "../../components/SuccessPopup";
import { getBalance } from "../../asyncAction/asyncBalance";
import TipPopup from "../../components/TipPopup";
import Chat from "../../components/Chat";
import Online from "../../components/Chat/online";
import DropDown from "../../components/DropDown";
import CommonRow from "../../components/CommonRow";
import PlaylistMusic from "./playlistMusic";
import { arrayMoveImmutable } from "array-move";
import StreamingDetailPoup from "../../components/Stream/StreamingDetailPoup";
import { startStream } from "../../action/stream";
import { hideChat } from "../../action/chat";
import { SocketContext } from "../../context/socket";
import IosShareIcon from "@mui/icons-material/IosShare";
import { useTranslation } from "react-i18next";
import { start } from "../../action/streamSong";
import HMSTag from "../../components/HMS/hms";
export default function MyMusic(props) {
  const { t } = useTranslation("common");
  const [playlistData, setPlaylistData] = useState(null);
  const { isStream } = useSelector((state) => state.stream);
  const socket = useContext(SocketContext).Socket;
  const [openAlbumMenu, setAlbumMenu] = React.useState(false);
  const history = useHistory();
  const [showSuccess, setShowSuccess] = useState(false);
  const [isAlbum, setIsAlbum] = React.useState(false);
  const dispatch = useDispatch();
  const songs = useSelector((state) => state.songs);
  const { id } = useParams();
  const { playListId } = useParams();
  const { albumId } = useParams();
  const [views, setViews] = useState("");
  const [listens, setListens] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openTip, setOpenTip] = React.useState(false);
  const [openTipPlaylistMusic, setOpenTipPlaylistMusic] = React.useState(false);
  const [musicArtist, setMusicArtist] = useState(null);
  const [musicId, setMusicId] = useState(null);
  const [openPopup, setOpenPopup] = React.useState(false);
  const [music, setMusic] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const userDetail = getUserDetail();
  const [duration, setDuration] = useState(0);
  const [pageNo, setPageno] = useState(1);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [gif, setGif] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [owner, setOwner] = useState(null);
  const [artist, setArtist] = useState("");
  const [loader, setLoader] = useState(true);
  const [title, setTitle] = useState("");
  const [isPrivate, setPrivate] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatCount, setChatCount] = useState(0);
  const [createdByDetails, setCreatedByDetails] = useState();
  const [tipOrStream, setTipOrStream] = useState(t("dropDown.text1"));
  const [menuKey, setMenuKey] = useState("text1");
  const [tipOrStreamList, setTipOrStreamList] = useState([]);
  const show = useSelector((state) => state.chat["show"]);
  const forceUpdate = React.useCallback(() => setMusic([]), []);
  const [live, setLive] = useState(false);
  const [isStreamingPopup, setIsStreamingPopup] = React.useState(false);
  const [option, setOption] = React.useState(false);
  const params = new URLSearchParams(history.location.search);
  const referralId = params.get("referralId");
  const [nftDetails, setNftDetails] = React.useState({});
  useEffect(() => {
    if (show && chatOpen) setChatOpen(false);
  }, [show]);
  const toggleMenu = (value, id, index) => {
    setOpen(false);
    setAlbumMenu(false);
    setSelectedAlbum(id);
    setSelectedIndex(index);

    if (value && id) makeAction(value, id, index);
    else if (value) makeAction(value);
  };

  const makeAction = (key, id, index) => {
    switch (key) {
      case "m1":
        if (music[index]?.nftId)
          history.push(`/app/SongDetail/${music[index]?.nftId}`);
        else history.push(`/app/SongDetails/${id}`);
        break;
      case "m3":
        if (
          playListId &&
          !isOwnerId(
            createdBy
              ? createdBy
              : music[index]["owner"]
              ? music[index]["owner"]["_id"]
              : music[index]["uploader"]
              ? music[index]["uploader"]["_id"]
              : ""
          ) &&
          !isSubscribed &&
          isPrivate
        )
          notifier.error(t("notifier.error.toast15"));
        else {
          setIsAlbum(false);
          setShowPlaylist(true);
        }

        break;
      case "m4":
        setIsAlbum(true);
        setShowPlaylist(true);
        break;
      case "m6":
        markPrivate(id, index);
        break;
      case "m5":
        markPrivate(id, index);
        break;

      case "m2":
        if (playListId && !isOwnerId(createdBy) && !isSubscribed && isPrivate)
          notifier.error(t("notifier.error.toast5"));
        else if (
          playListId &&
          !isOwnerId(createdBy) &&
          typeof music[index]["uploader"] === "object" &&
          !music[index]["uploader"]["isSubscribed"] &&
          music[index]["private"]
        ) {
          notifier.error(t("notifier.error.toast5"));
        } else
          dispatch(
            addSongAction(music[index], playListId ? playListId : null, true)
          );
        break;
      case "m7":
        setOpenPopup(true);
        break;
      case "m26":
        if (music.length > 0)
          dispatch(
            addSongsAction(music, false, playListId ? playListId : null, 0)
          );
        break;
      case "m10":
        deleteSongFromPlaylist(music[index]["_id"], playListId, index);
        break;
      case "m21":
        deleteAlbum();
        break;
      case "m24":
        deletePlaylist();
        break;

      case "m9":
        deleteSongFromAlbum(index);
        break;
      case "Sell NFT":
        history.push(`/app/SellAuction/${music[index]["nftId"]}`);
        break;
      case "m22":
        savePlaylist(id);
        break;
      case "m8":
        history.push(`/app/MyNft/${music[index]["nftId"]}`);
        break;

      default:
        break;
    }
  };
  const deleteSongFromPlaylist = async (musicId, playlistId, index) => {
    if (musicId && playlistId) {
      setLoading(true);
      try {
        const response = await ApiService.REMOVE_SONG_FROM_PLAYLIST({
          musicId: musicId,
          playlistId: playlistId,
        });
        const tempMusic = music;
        tempMusic.splice(index, 1);
        setMusic([...tempMusic]);
        setLoading(false);
      } catch (error) {
        notifier.error(getErrorString(error));
        setLoading(false);
      }
    }
  };
  const savePlaylist = async (id) => {
    if (!isOwnerId(createdByDetails["_id"]) && !isPrivate) {
      try {
        setLoading(true);
        const response = await ApiService.SAVE_PLAYLIST({
          playlistId: playListId,
        });
        setLoading(false);
        notifier.success(t("notifier.success.toast7"));
      } catch (error) {
        setLoading(false);
      }
    } else {
      notifier.error(t("notifier.error.toast9"));
    }
  };
  //Delete album
  const deleteAlbum = async () => {
    try {
      setLoading(true);
      const response = await ApiService.DELETE_ALBUM(albumId);

      setLoading(false);
      history.goBack();
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  //Delete album
  const deleteSongFromAlbum = async (index) => {
    try {
      setLoading(true);
      const response = await ApiService.DELETE_SONG_FROM_ALBUM({
        musicId: music[index]["_id"],
        albumId: albumId,
      });
      const temp = music;
      temp.splice(index, 1);
      setMusic([...temp]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const markPrivate = async (id, index) => {
    try {
      setLoading(true);
      const response = await ApiService.ASSET_PRIVACY({
        assetId: id,
        type: "music",
        private: !music[index].private,
      });
      if (music[index]["nftId"]) {
        const response = await ApiService.ASSET_PRIVACY({
          assetId: music[index]["nftId"],
          type: "nft",
          private: !music[index].private,
        });
      }

      const temp = music;
      temp[index].private = !temp[index].private;
      setMusic([...temp]);
      notifier.success(response["result"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (userDetail) {
      //console.log(music);
      if (playListId) {
        getPlayListMusic(playListId, pageNo, []);
        getTipOrStreamList(playListId, "Tips", false);
      } else if (albumId) getAlbumMusic(albumId, pageNo);
      else getMyMusic(id ? id : userDetail["_id"], pageNo);
    }
  }, [history.location.pathname]);

  const getMyMusic = async (_id, page) => {
    try {
      setLoading(true);

      const response = await ApiService.ALL_ARTIST_MUSIC({
        _id: _id,
        pageNo: 1,
        pageSize: 1,
      });

      setLoading(false);
      // setLoader(response["result"]["music"].length < 16 ? false : true);
      // setMusic([...music, ...response["result"]["music"]]);
      const tempMusic = await getAllMusicOfuser(getUserId());

      if (tempMusic.length > 0) setMusic([...tempMusic]);
      setGif("");
      setTitle("");
      setPrivate(false);
      setCreatedBy("");
      setViews("");

      setCreatedByDetails("");
      // if (page > 1 && songs["index"] >= 0)
      //   dispatch(addSongsAction(response["result"]["music"], true, false, 0));
      setDuration(response["result"]["totalDuration"]);
    } catch (error) {
      setPageno(page - 1);
      setLoading(false);
      if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
    }
  };
  const getPlayListMusic = async (_id, pageNo, data) => {
    //console.log(music);
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: pageNo,
        pageSize: 16,
      });
      setPlaylistData(response["result"]);
      if (window.location.href.includes("referralId="))
        putRecors({
          id: userDetail._id,
          referralLink: window.location.href,
          eventType: ["sharedInbound"],
          eventAsset: response["result"]._id,
          eventValue: ["Studio"],
          socialMedia: null,
          referralId: referralId,
        });
      else
        putRecors({
          id: userDetail._id,
          referralLink: response["result"].shareUrl.shortLink,
          eventType: ["view"],
          eventAsset: response["result"]._id,
          eventValue: ["Studio"],
          socialMedia: null,
        });

      const currentResponse = await individualSongTipper(_id);
      for (var i = 0; i < currentResponse.length; i++) {
        var elementPos = response["result"]["music"]
          .map(function (x) {
            return x._id;
          })
          .indexOf(currentResponse[i]["musicId"]);
        //console.log("element pos", elementPos);
        if (elementPos >= 0) {
          response["result"]["music"][elementPos].topTipperId = currentResponse[
            i
          ]["topTipperId"]
            ? currentResponse[i]["topTipperId"]
            : "";
          response["result"]["music"][elementPos].topTipperName =
            currentResponse[i]["topTipperName"]
              ? currentResponse[i]["topTipperName"]
              : "";
          response["result"]["music"][elementPos].topTipperProfile =
            currentResponse[i]["topTipperProfile"]
              ? currentResponse[i]["topTipperProfile"]
              : { filePath: "" };

          // response["result"]["music"][i].topTipperId = "";
          // response["result"]["music"][i].topTipperName = "";
          // response["result"]["music"][i].topTipperProfile = {"filePath" : ""};
        }
      }
      setLoading(false);
      setLoader(response["result"]["music"].length < 16 ? false : true);
      setMusic([...data, ...response["result"]["music"]]);
      // if (pageNo > 1 && songs["index"] >= 0)
      //   dispatch(addSongsAction(response["result"]["music"], true, false, 0));
      // setMusic([...response["result"]["music"]]);
      setGif(
        response["result"]["GIF"]
          ? response["result"]["GIF"]["filePath"]
          : response["result"]["thumbnailImg"]
          ? response["result"]["thumbnailImg"]["filePath"]
          : Images.album
      );
      setLive(response["result"]["live"]);
      setCreatedBy(response["result"]["createdBy"]);
      setOwner(response?.result?.nftOwner?.owner);
      setTitle(response["result"]["title"]);
      setPrivate(response["result"]["private"]);
      setNftDetails({ ...response["result"]?.nftOwner });
      setIsSubscribed(response["result"]["isSubscribed"]);
      setListens(response["result"]["listens"]);
      setViews(response["result"]["views"]);
      setDuration(response["result"]["totalDuration"]);
      if (
        playListId &&
        !isOwnerId(response["result"]["createdBy"]) &&
        !response["result"]["isSubscribed"] &&
        response["result"]["private"]
      ) {
        notifier.error(t("notifier.error.toast7"));
        history.push(`/app/ArtistProfile/${response["result"]["createdBy"]}`);
      }
      if (response["result"]["createdByDetails"])
        setCreatedByDetails(response["result"]["createdByDetails"]);
    } catch (error) {
      setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        notifier.error(getErrorString(error));
        history.push("/app/Home");
      } else if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
    }
  };

  const getAlbumMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.ALBUM_DETAILS({
        _id: _id,
        pageNo: pageNo,
        pageSize: 16,
      });

      setLoading(false);
      setArtist(response["result"]["artist"]);
      setTitle(response["result"]["title"]);
      setMusic([...response["result"]["music"]]);
      setListens(response["result"]["listens"]);
      setViews(response["result"]["views"]);
      setDuration(response["result"]["totalDuration"]);
      setGif(
        response["result"]["GIF"]
          ? response["result"]["GIF"]["filePath"]
          : response["result"]["thumbnailImg"]
          ? response["result"]["thumbnailImg"]["filePath"]
          : Images.album
      );
    } catch (error) {
      setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        notifier.error(getErrorString(error));
        history.push("/app/Home");
      } else if (getErrorString(error) !== "Artist has no music")
        notifier.error(getErrorString(error));
    }
  };
  const playAll = async (index) => {
    let showError = false;
    music[index]["artistData"].forEach((e) => {
      if (isOwnerId(e["uId"])) {
        showError = true;
      }
    });
    if (
      playListId &&
      !isOwnerId(createdBy ? createdBy : "") &&
      !isSubscribed &&
      isPrivate
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (
      albumId &&
      !showError &&
      !isSubscribed &&
      music[index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (
      playListId &&
      !isOwnerId(
        createdBy
          ? createdBy
          : music[index]["owner"]
          ? music[index]["owner"]["_id"]
          : music[index]["uploader"]
          ? music[index]["uploader"]["_id"]
          : ""
      ) &&
      music[index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (music && music.length > 0) {
      if (playListId) {
        dispatch(
          addSongsAction(
            music,
            false,
            playListId ? playListId : null,
            index !== undefined ? index : 0
          )
        );
      } else {
        // const tempMusic = await getAllMusicOfuser(getUserId());
        if (music.length > 0)
          dispatch(
            addSongsAction(
              music,
              false,
              playListId ? playListId : null,
              index !== undefined ? index : 0,
              albumId ? albumId : null
            )
          );
      }
    }
  };
  const getAllMusicOfuser = async (userId) => {
    try {
      setLoading(true);
      const response = await ApiService.MY_MUSIC(`assetId=${userId}&type=user`);
      setLoading(false);
      return response["result"];
    } catch (error) {
      setLoading(false);
      return [];
    }
  };
  const play = (index, musics) => {
    if (
      playListId &&
      !isOwnerId(
        createdBy
          ? createdBy
          : music[index]["owner"]
          ? music[index]["owner"]["_id"]
          : music[index]["uploader"]
          ? music[index]["uploader"]["_id"]
          : ""
      ) &&
      typeof music[index]["uploader"] === "object" &&
      !music[index]["uploader"]["isSubscribed"] &&
      isPrivate
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (
      playListId &&
      !isOwnerId(
        createdBy
          ? createdBy
          : music[index]["owner"]
          ? music[index]["owner"]["_id"]
          : music[index]["uploader"]
          ? music[index]["uploader"]["_id"]
          : ""
      ) &&
      typeof music[index]["uploader"] === "object" &&
      !music[index]["uploader"]["isSubscribed"] &&
      music[index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    }
    // dispatch(
    //   addSongAction(musics[index], playListId ? playListId : null, false)
    // );
    else {
      dispatch(
        addSongAction(musics[index], playListId ? playListId : null, false)
      );
    }
  };
  const createNft = async (musicId, currency, units, platform) => {
    try {
      setLoading(true);
      const res = await ApiService.CREATE_MUSIC_NFT_V4({
        musicId: musicId,
        private: false,
        currency: currency,
        count: parseInt(units),
        platform: platform,
      });
      dispatch(getBalance());
      setLoading(false);
      const m = music;
      m[selectedIndex]["nftId"] = res["result"]._id;
      setMusic([...m]);
      setOpenPopup(false);
      setShowSuccess(true);
    } catch (error) {
      setLoading(false);
      setOpenPopup(false);
      notifier.error(getErrorString(error));
    }
  };

  const deletePlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.DELETE_PLAYLIST(playListId);
      notifier.success("Playlist deleted");
      history.goBack();

      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  React.useEffect(() => {}, [songs]);
  const handleClose = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_PLAYLIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTip(false);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const handleCloseTip = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTipPlaylistMusic(false);
        setMusicId(null);
        setMusicArtist(null);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTipPlaylistMusic(false);
    }
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && loader && !loading) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageno(next);
      if (userDetail) {
        if (playListId) getPlayListMusic(playListId, next, music);
        else if (albumId) getAlbumMusic(albumId);
        // else getMyMusic(id ? id : userDetail["_id"], next);
      }
    }
  };
  const individualSongTipper = async (playlistID) => {
    try {
      const response = await ApiService.INDIVIDUAL_SONG_TIPPER({
        id: playlistID,
      });
      return response["result"];
    } catch (error) {
      //console.log(error);
      return [];
    }
  };
  const getTipOrStreamList = async (playlistId, tOrS, toLoad) => {
    setLoading(true);
    try {
      var response;
      if (tOrS === "Tips") {
        response = await ApiService.GET_PLAYLIST_MOST_TIPPED(
          `playlistId=${playlistId}`
        );
      } else {
        response = await ApiService.GET_PLAYLIST_MOST_STREAMED(
          `playlistId=${playlistId}`
        );
      }
      setTipOrStreamList([...response["result"]]);
      if (toLoad) setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    setMusic([]);

    return () => {
      setMusic([]);
      setGif();
      setChatOpen(false);
      setPageno(1);
    };
  }, [history.location.pathname]);

  const onSortEnd = async ({ oldIndex, newIndex }) => {
    setMusic((music) => arrayMoveImmutable(music, oldIndex, newIndex));
    const data = arrayMoveImmutable(music, oldIndex, newIndex);
    const musicList = data.map((m) => m._id);
    try {
      const payload = {
        playlistId: playListId,
        musicList: musicList,
      };
      await ApiService.SORT_PLAYLIST_MUSIC(payload);
    } catch (error) {
      notifier.error(getErrorString(error));
    }
  };
  const onSortStart = ({ node, index }) => {
    // const row = node.classList;
    // row.add('__sotable_table_row');
    node.style.display = "flex";
    node.style.flexDirection = "row";
    node.style.justifyContent = "space-between";
    node.style.marginLeft = "0";
    // node.children[2].style.display = 'flex';
    // node.children[2].style.alignItems = 'center';
    // node.children[2].style.justifyContent = 'flex-end';
    // node.style.paddingRight = '20px';
  };
  const updateBeforeSortStart = ({ node, index }) => {
    // const row = node.classList;
    // row.add('__sotable_table_row');
    node.style.display = "flex";
    node.style.flexDirection = "row";
    node.style.justifyContent = "space-between";
    // node.style.marginLeft = '20px';
    node.children[0].style.paddingLeft = "20px";
    node.children[3].style.paddingRight = "20px";
    node.children[1].style.display = "flex";
    node.children[1].style.flexDirection = "row";
    node.children[1].style.justifyContent = "space-between";
    node.children[0].style.width = "25%";
    node.children[1].style.width = "25%";
    // node.children[2].style.display = 'flex';
    // node.children[2].style.alignItems = 'center';
    node.children[2].style.textAlign = "right";

    node.children[2].style.width = "25%";
    node.children[3].style.width = "25%";
    node.children[3].style.textAlign = "right";

    // node.style.paddingRight = '20px';
  };
  useEffect(() => {
    if (socket) {
      socket.on("stream-joined", function (data) {
        const userId = getUserId();
        if (
          playListId &&
          data.channelName === playListId &&
          data.userId !== userId
        ) {
          setLive(true);
        }
      });
      socket.on("stream-ended", function (data) {
        const isOwner = isOwnerId(createdBy);
        if (
          playListId &&
          data.channelName === playListId &&
          data.role === "host" &&
          !isOwner
        ) {
          setLive(false);
        }
      });
    }
  }, [socket]);

  const handleJoin = async () => {
    const status = await getBlockedUserOfPlaylist(playListId);
    if (typeof status === "boolean" && status) {
      notifier.error(t("notifier.error.toast2"));

      return;
    } else {
      dispatch(
        startStream({
          streamData: {
            title: title,
            _id: playListId,
            owner: owner,
          },
          title: null,
          goal: null,
          goalDescription: null,
          isNew: false,
        })
      );
    }
  };
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      return response?.result?.isBlocked;
    } catch (error) {
      return null;
    }
  };
  const handleCopy = async (action) => {
    const url =
      playlistData?.shareUrl?.shortLink ||
      (await dynamicLink(
        `/signup?returnUrl=/app/ArtistProfile/${props["userData"]._id}`
      ));
    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: userDetail._id,
          referralLink: playlistData.shareUrl.shortLink,
          eventType: ["sharedOutbound"],
          eventAsset: playListId,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: userDetail._id,
          referralLink: playlistData.shareUrl.shortLink,
          eventType: ["sharedOutbound"],
          eventAsset: playListId,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  const handleClick = (event) => {
    setOption(!option);

    putRecors({
      id: userDetail._id,
      referralLink: playlistData.shareUrl.shortLink,
      eventType: ["click"],
      eventAsset: playListId,
      sharedBy: fullName(userDetail),
      eventValue: ["Studio"],
      socialMedia: null,
    });
  };
  const handleClosed = () => {
    setOption(false);
  };
  return (
    <Box className={"_position_relative" + (chatOpen ? " _chat_open" : "")}>
      <Box className={" _chat_opened_music"}>
        <Box
          sx={{
            color: "#999999",
            display: "flex",
            alignItems: "center",
            padding: "0 20px 20px",
            width: "40px",
          }}
          className="_cp fs-14"
          onClick={() => history.goBack()}
        >
          <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} />{" "}
          {t("back")}
        </Box>

        <Box sx={{ position: "relative" }}>
          {music.length > 0 || title ? (
            <Box>
              <Box sx={{ position: "relative" }}>
                <Box>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    padding={chatOpen ? "10px 0px 10px 0px" : "10px 0px"}
                  >
                    <Stack
                      spacing={1.5}
                      direction="row"
                      gap="20px"
                      padding="10px 0px 10px 20px"
                    >
                      <img
                        className="_img_medium  br16"
                        src={
                          gif
                            ? gif
                            : music.length > 0
                            ? music[0]["thumbnailImg"]["filePath"]
                            : ""
                        }
                        alt="music"
                      />
                      <Stack
                        direction="column"
                        justifyContent="center"
                        spacing={1}
                      >
                        {playListId ? (
                          <Typography
                            className="fs-20 _cp"
                            onClick={() =>
                              history.push(
                                `/app/ArtistProfile/${createdByDetails["_id"]}`
                              )
                            }
                          >
                            {createdByDetails ? fullName(createdByDetails) : ""}
                          </Typography>
                        ) : null}
                        <Stack
                          direction={
                            !albumId && !playListId && !id ? "column" : "row"
                          }
                          alignItems={
                            !albumId && !playListId && !id
                              ? "flex-start"
                              : "center"
                          }
                          spacing={1}
                        >
                          {albumId ? (
                            <Typography className="fs-20">{title}</Typography>
                          ) : null}
                          {!albumId && !playListId && !id ? (
                            <Typography className="fs-20">
                              {t("myMusic.title")}
                            </Typography>
                          ) : null}

                          {((music && music.length > 0) || playListId) &&
                          !albumId ? (
                            <Typography
                              className={
                                playListId
                                  ? "fs-20  _cd"
                                  : "fs-14 fade-text-60 _cd"
                              }
                              align="left"
                              style={{ marginTop: !playListId ? "0" : "" }}
                            >
                              {!playListId
                                ? fullName(music[0]["uploader"])
                                : title}
                            </Typography>
                          ) : null}
                          {playListId && isPrivate ? (
                            <LockIcon
                              sx={{
                                width: "14px",
                                height: "14px",
                                padding: "3px",
                                color: "#ffffff",
                                backgroundColor: "#4E4E4E",
                              }}
                              className="__small_icon"
                            />
                          ) : null}
                        </Stack>

                        <Stack
                          direction="row"
                          justifyContent="flex-start"
                          spacing={1}
                          sx={{ marginTop: "15 !important" }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#FFFFFF",
                              fontWeight: "bold !important",
                            }}
                          >
                            {music.length} {t("myMusic.songs")}
                          </Typography>
                          {duration ? <HMSTag duration={duration} /> : null}
                        </Stack>
                        {playListId ? (
                          <Stack direction="row" spacing={2}>
                            {/* <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <VisibilityIcon color="default" />{" "}
                              <Typography className="fs-14 fw-b">
                                {t("nftDetail.detail.views")}: {views}
                              </Typography>
                            </Stack> */}
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <img
                                style={{ width: "15px", height: "15px" }}
                                src={Images.listen}
                                alt=""
                              />{" "}
                              <Typography className="fs-14 fw-b">
                                {t("analytics.card.card3")}: {listens}
                              </Typography>
                            </Stack>
                          </Stack>
                        ) : null}
                        <Stack
                          direction="row"
                          gap="10px"
                          alignItems="center"
                          flexWrap="wrap"
                        >
                          <Stack direction="row" gap="10px" alignItems="center">
                            {playListId ? (
                              <PlayArrowRoundedIcon
                                className="_cp br-50 b-white"
                                color="default"
                                onClick={() => playAll(0)}
                              />
                            ) : (
                              <Button
                                onClick={() => playAll(0)}
                                className="__play_all"
                                sx={{
                                  width: "130px",
                                  height: "36px !important",
                                  marginTop: "22px",
                                  fontSize: "15px !important",
                                  fontWeight: "400 !important",
                                  whiteSpace: "nowrap",
                                }}
                                variant="outlined"
                                color="default"
                                startIcon={
                                  <PlayArrowRoundedIcon
                                    className="__play_all_play"
                                    color="default"
                                  />
                                }
                              >
                                {t("myMusic.play")}
                              </Button>
                            )}
                            {playListId ? (
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <Button
                                  sx={{ whiteSpace: "pre" }}
                                  variant="outlined"
                                  color="default"
                                  startIcon={
                                    <img src={Images.activity} alt="" />
                                  }
                                  onClick={() =>
                                    history.push(
                                      `/app/PlaylistStatics/${playListId}/${createdBy}`
                                    )
                                  }
                                >
                                  {t("nftDetail.detail.statics")}
                                </Button>
                                {isOwnerId(owner) ? null : (
                                  <Button
                                    title="Tip studio"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setOpenTip(true)}
                                  >
                                    {t("tip")}
                                  </Button>
                                )}

                                {albumId || playListId ? (
                                  <Box
                                    sx={{
                                      position: "relative",
                                      marginTop: albumId ? "22px" : "0px",
                                    }}
                                  >
                                    <MoreVertIcon
                                      className="_cp"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setAlbumMenu(!openAlbumMenu);
                                      }}
                                      color="default"
                                    />

                                    {openAlbumMenu ? (
                                      <OutsideClickHandler
                                        onOutsideClick={() =>
                                          setAlbumMenu(false)
                                        }
                                      >
                                        <DropMenu
                                          isMenu={open}
                                          actions={[
                                            {
                                              key: "m26",
                                              action: t("dropMenu.m26"),
                                            },
                                            albumId && getUserId() === artist
                                              ? {
                                                  key: "m21",
                                                  action: t("dropMenu.m21"),
                                                }
                                              : "",
                                            // playListId && getUserId() === createdBy
                                            //   ? "Remove Playlist"
                                            //   : "",
                                            playListId && getUserId() !== owner
                                              ? {
                                                  key: "m22",
                                                  action: t("dropMenu.m22"),
                                                }
                                              : "",
                                          ]}
                                          toggleMenu={(action) =>
                                            toggleMenu(action, music._id, null)
                                          }
                                        />
                                      </OutsideClickHandler>
                                    ) : null}
                                  </Box>
                                ) : null}
                              </Stack>
                            ) : null}
                          </Stack>
                          <Stack direction="row" gap="10px" alignItems="center">
                            {playListId ? (
                              <Box sx={{ position: "relative" }}>
                                <Button
                                  className="__play_all "
                                  onClick={handleClick}
                                  sx={{
                                    width: "96px",
                                    height: "36px !important",
                                    fontSize: "12px !important",
                                    fontWeight: "400 !important",
                                  }}
                                  variant="outlined"
                                  color="default"
                                  startIcon={
                                    <IosShareIcon
                                      className="__play_all_play"
                                      color="default"
                                    />
                                  }
                                >
                                  {t("nftDetail.detail.share")}
                                </Button>
                                {option ? (
                                  <OutsideClickHandler
                                    onOutsideClick={() => {
                                      handleClosed();
                                    }}
                                  >
                                    <DropMenu
                                      right={""}
                                      isHeader={true}
                                      isLast={"40px"}
                                      actions={[
                                        {
                                          key: "m14",
                                          action: t("dropMenu.m14"),
                                        },
                                        {
                                          key: "m15",
                                          action: t("dropMenu.m15"),
                                        },
                                        {
                                          key: "m16",
                                          action: t("dropMenu.m16"),
                                        },
                                        // "Share on Instagram",
                                        ,
                                      ]}
                                      toggleMenu={(action) => (
                                        handleCopy(action), handleClosed()
                                      )}
                                    />
                                  </OutsideClickHandler>
                                ) : null}
                              </Box>
                            ) : null}

                            {(playListId &&
                              isPrivate &&
                              !isSubscribed &&
                              !isOwnerId(createdBy)) ||
                            props.location.pathname.includes("/app/MyMusic") ||
                            albumId ? null : (
                              <IconButton
                                onClick={() => {
                                  setChatOpen(true);
                                  dispatch(hideChat(false));
                                }}
                              >
                                <img
                                  title="Open chat"
                                  style={{ width: "24px" }}
                                  src={Images.chat}
                                  alt="chat"
                                />
                              </IconButton>
                            )}
                            {isOwnerId(owner) &&
                            !isStream &&
                            playListId &&
                            !nftDetails?.onAuction &&
                            !nftDetails?.onSale ? (
                              <IconButton
                                className="_playlist_streaming_camera"
                                onClick={() => setIsStreamingPopup(true)}
                              >
                                <img
                                  title="Open live streaming"
                                  style={{ width: "24px" }}
                                  src={Images.streaming_filled}
                                  alt="camera"
                                />
                              </IconButton>
                            ) : !isOwnerId(owner) && playListId && live ? (
                              <IconButton
                                className="_playlist_streaming_camera"
                                onClick={() => handleJoin()}
                              >
                                <img
                                  title="Open live streaming"
                                  style={{ width: "24px" }}
                                  src={Images.streaming_filled}
                                  alt="camera"
                                />
                              </IconButton>
                            ) : null}
                          </Stack>
                        </Stack>
                        {albumId ? (
                          <Stack direction="row" spacing={2}>
                            {/* <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <VisibilityIcon color="default" />{" "}
                              <Typography className="fs-14 fw-b">
                                {t("nftDetail.detail.views")}: {views}
                              </Typography>
                            </Stack> */}
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <img
                                style={{ width: "15px", height: "15px" }}
                                src={Images.listen}
                                alt=""
                              />{" "}
                              <Typography className="fs-14 fw-b">
                                {t("nftDetail.detail.stream")}: {listens}
                              </Typography>
                            </Stack>
                          </Stack>
                        ) : null}
                      </Stack>
                    </Stack>
                    {/* tipper/streamer drop down */}
                    {playListId ? (
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{
                          marginLeft: "auto",
                          marginRight: "55px",
                          width: "170px",
                        }}
                      >
                        <DropDown
                          _class="_playlist_topfive_dropdown_container"
                          onChange={({ key }) => {
                            if (key === "text1")
                              getTipOrStreamList(playListId, "Tips", true);
                            else getTipOrStreamList(playListId, "Stream", true);
                            setTipOrStream(t(`dropDown.${key}`));
                            setMenuKey(key);
                          }}
                          title={tipOrStream}
                          menuKey={menuKey}
                          values={[
                            { key: "text1", value: t("dropDown.text1") },
                            { key: "text2", value: t("dropDown.text2") },
                          ]}
                        />
                        <Stack
                          spacing={0.5}
                          sx={{
                            maxHeight: "150px",
                            overflow: "scroll",
                            width: "fit-content",
                          }}
                        >
                          {tipOrStreamList.map((ts, index) => (
                            <Stack
                              key={index}
                              direction="row"
                              spacing={1}
                              alignItems="flex-end"
                            >
                              <Avatar
                                src={
                                  ts?.profilePic?.filePath
                                    ? ts["profilePic"]["filePath"]
                                    : Images.dummy1
                                }
                              />
                              <Stack>
                                <Typography
                                  onClick={() =>
                                    history.push(
                                      `/app/ArtistProfile/${ts["_id"]}`
                                    )
                                  }
                                  className="fs-14 text-white _cp"
                                  sx={{
                                    color: "#FFFFFF",
                                    whiteSpace: "pre",
                                  }}
                                >
                                  {ts["fullName"]}
                                </Typography>
                                <Typography
                                  className="fs-14 text-white"
                                  sx={{
                                    color: "#FFFFFF",
                                    align: "right",
                                  }}
                                >
                                  {menuKey === "text1"
                                    ? `$${
                                        ts["highestTipped"]
                                          ? ts["highestTipped"].toFixed(2)
                                          : ""
                                      }`
                                    : kFormatter(ts["streamCount"])}
                                </Typography>
                              </Stack>
                            </Stack>
                          ))}
                        </Stack>
                      </Stack>
                    ) : null}
                  </Stack>
                </Box>
                <Box className="__back_cover">
                  <img
                    className=" mx-auto h100 w100"
                    src={
                      gif
                        ? gif
                        : music.length > 0
                        ? music[0]["thumbnailImg"]["filePath"]
                        : ""
                    }
                    alt="music"
                  />
                </Box>
              </Box>
              {music.length > 0 && !playListId ? (
                <Box
                  onScroll={(e) => handleScroll(e.target)}
                  sx={{
                    padding: "0 0 220px 0px",
                    maxHeight: "70vh",
                    overflow: "scroll",
                  }}
                >
                  <table className="mymusic_table">
                    <thead
                      style={{
                        position: "sticky",
                        top: "0",
                        zIndex: "1",
                        // backgroundColor: "#1e1e1e",
                        backgroundColor: "#090909",
                      }}
                    >
                      <tr>
                        <th style={{ width: !playListId ? "50%" : "auto" }}>
                          {t("myMusic.table.header1")}
                        </th>
                        {playListId ? (
                          <th style={{ textAlign: "inherit" }}>Top Tipper</th>
                        ) : null}
                        {playListId ? <th></th> : null}
                        <th style={{ width: !playListId ? "25%" : "auto" }}>
                          {t("myMusic.table.header2")}
                        </th>
                        <th style={{ width: !playListId ? "25%" : "auto" }}>
                          {t("myMusic.table.header3")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {music.map((m, index) => (
                        <tr key={index} style={{ position: "relative" }}>
                          <td>
                            <Stack direction="row" spacing={2}>
                              <Stack
                                className="__music_thumb _cp"
                                sx={{ justifyContent: "center" }}
                              >
                                <Avatar
                                  src={
                                    m["thumbnailImg"]["filePath"]
                                      ? m["thumbnailImg"]["filePath"]
                                      : Images.circle_music
                                  }
                                />
                                <img
                                  onClick={() => playAll(index, music)}
                                  className="__play_hover"
                                  src={Images.play}
                                  alt="play"
                                />
                              </Stack>
                              <Stack direction="column">
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  alignItems="center"
                                >
                                  <Typography
                                    variant="body1"
                                    className="fs-16 "
                                    onClick={() =>
                                      playListId
                                        ? history.push(`/app/Music/${m["_id"]}`)
                                        : history.push(
                                            `/app/SongDetails/${m["_id"]}`
                                          )
                                    }
                                  >
                                    {m["title"] ? m["title"] : ""}
                                  </Typography>
                                  {m["private"] ? (
                                    <LockIcon
                                      sx={{
                                        width: "11px",
                                        height: "11px",
                                        padding: "2px",
                                        color: "#989898",
                                        backgroundColor: "#4E4E4E",
                                      }}
                                      className="__small_icon _lock_hover"
                                    />
                                  ) : null}
                                </Stack>
                                <Stack
                                  direction="row"
                                  style={{
                                    overflowY: "scroll",
                                    width:
                                      m["artistData"]?.length > 2
                                        ? "245px"
                                        : "",
                                    gap: "5px",
                                  }}
                                  className="scroll_display_musicCard"
                                >
                                  {m["artistData"] ? (
                                    m["artistData"].length > 1 ? (
                                      m["artistData"].map((a, index) => (
                                        <Typography
                                          onClick={() =>
                                            history.push(
                                              `/app/ArtistProfile/${a.uId}`
                                            )
                                          }
                                          variant="body2"
                                          className="fs-14 fade-text _cp"
                                          key={index}
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {a?.displayArtistName}
                                          {m["artistData"].length - 1 == index
                                            ? ""
                                            : ","}
                                        </Typography>
                                      ))
                                    ) : (
                                      m["artistData"].map((a, index) => (
                                        <Typography
                                          onClick={() =>
                                            history.push(
                                              `/app/ArtistProfile/${a.uId}`
                                            )
                                          }
                                          variant="body2"
                                          className="fs-14 fade-text _cp"
                                          key={index}
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {a?.displayArtistName}
                                        </Typography>
                                      ))
                                    )
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      className="fs-14 fade-text"
                                    >
                                      {m["artist"]
                                        ? m["artist"].replace(/\//g, ", ")
                                        : ""}
                                    </Typography>
                                  )}
                                </Stack>
                              </Stack>
                            </Stack>
                          </td>
                          {playListId ? (
                            <td className="text-center ">
                              {m["topTipperProfile"] &&
                              m["topTipperProfile"]["filePath"] &&
                              m["topTipperName"] ? (
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  alignItems="flex-end"
                                >
                                  <Avatar
                                    src={
                                      m["topTipperProfile"]["filePath"]
                                        ? m["topTipperProfile"]["filePath"]
                                        : ""
                                    }
                                  />
                                  <Typography
                                    onClick={() =>
                                      history.push(
                                        `/app/ArtistProfile/${m["topTipperId"]}`
                                      )
                                    }
                                    className="fs-14 text-white _cp"
                                    sx={{
                                      color: "#00C3FD",
                                    }}
                                  >
                                    {m["topTipperName"]
                                      ? m["topTipperName"]
                                      : ""}
                                  </Typography>
                                </Stack>
                              ) : null}
                            </td>
                          ) : null}
                          {playListId ? (
                            <td>
                              {!isOwnerId(m["topTipperId"]) &&
                              m["topTipperId"] ? (
                                <img
                                  className="_cp"
                                  onClick={() => {
                                    setOpenTipPlaylistMusic(true);
                                    setMusicId(m["topTipperId"]);
                                    setMusicArtist(m["topTipperName"]);
                                  }}
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                  }}
                                  src={Images.tip_hover_player}
                                  alt="tip"
                                />
                              ) : null}
                            </td>
                          ) : null}
                          <td className="text-center text-white fs-14">
                            {HMS(m["duration"])}
                          </td>
                          <td className="text-right pr18">
                            <MoreVertIcon
                              className="_cp"
                              onClick={() => {
                                // const t = items;
                                // t[3] = music["private"]
                                //   ? "Mark this Asset Public"
                                //   : "Mark this Asset Private";
                                // if (music["nftId"]) {
                                //   if (t[4]) t.splice(4, 1);
                                // } else t[4] = "Create NFT";
                                // setItems([...t]);

                                setSelectedIndex(index);
                                setOpen(!open);
                              }}
                              color="default"
                            />
                          </td>
                          {index === selectedIndex && open ? (
                            <OutsideClickHandler
                              onOutsideClick={() => setOpen(false)}
                            >
                              <DropMenu
                                isLast={
                                  index === music.length - 1 && music.length > 2
                                    ? "-90px !important"
                                    : "40px"
                                }
                                right={"0px"}
                                isMenu={open}
                                actions={
                                  playListId
                                    ? [
                                        {
                                          key: "m1",
                                          action: t("dropMenu.m1"),
                                        },
                                        {
                                          key: "m2",
                                          action: t("dropMenu.m2"),
                                        },
                                        {
                                          key: "m3",
                                          action: t("dropMenu.m3"),
                                        },
                                        // "Remove song",
                                        isOwnerId(createdBy)
                                          ? {
                                              key: "m10",
                                              action: t("dropMenu.m10"),
                                            }
                                          : "",
                                      ]
                                    : albumId
                                    ? [
                                        {
                                          key: "m1",
                                          action: t("dropMenu.m1"),
                                        },
                                        {
                                          key: "m2",
                                          action: t("dropMenu.m2"),
                                        },
                                        {
                                          key: "m3",
                                          action: t("dropMenu.m3"),
                                        },

                                        isOwner(
                                          m["owner"]
                                            ? m["owner"]["email"]
                                            : m["uploader"]
                                            ? m["uploader"]["email"]
                                            : ""
                                        )
                                          ? {
                                              key: "m9",
                                              action: t("dropMenu.m9"),
                                            }
                                          : "",
                                      ]
                                    : albumId
                                    ? [
                                        {
                                          key: "m1",
                                          action: t("dropMenu.m1"),
                                        },
                                        {
                                          key: "m2",
                                          action: t("dropMenu.m2"),
                                        },
                                        isOwner(m["uploader"]["email"])
                                          ? {
                                              key: "m9",
                                              action: t("dropMenu.m9"),
                                            }
                                          : "",
                                      ]
                                    : id
                                    ? [
                                        {
                                          key: "m1",
                                          action: t("dropMenu.m1"),
                                        },
                                      ]
                                    : [
                                        {
                                          key: "m1",
                                          action: t("dropMenu.m1"),
                                        },
                                        {
                                          key: "m2",
                                          action: t("dropMenu.m2"),
                                        },
                                        {
                                          key: "m3",
                                          action: t("dropMenu.m3"),
                                        },
                                        {
                                          key: "m4",
                                          action: t("dropMenu.m4"),
                                        },
                                        m["private"]
                                          ? {
                                              key: "m5",
                                              action: t("dropMenu.m5"),
                                            }
                                          : {
                                              key: "m6",
                                              action: t("dropMenu.m6"),
                                            },
                                        m["nftId"]
                                          ? ""
                                          : {
                                              key: "m7",
                                              action: t("dropMenu.m7"),
                                            },
                                        m["nftId"]
                                          ? {
                                              key: "m8",
                                              action: t("dropMenu.m8"),
                                            }
                                          : "",
                                        // music["nftId"] ? "Sell NFT" : "",
                                      ]
                                }
                                toggleMenu={(action) =>
                                  toggleMenu(action, m._id, index)
                                }
                              />
                            </OutsideClickHandler>
                          ) : null}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              ) : playListId ? (
                <PlaylistMusic
                  createdBy={createdBy}
                  useDragHandle
                  lockAxis="y"
                  onSortEnd={onSortEnd}
                  onSortStart={onSortStart}
                  updateBeforeSortStart={updateBeforeSortStart}
                  music={music}
                  playListId={playListId}
                  handleTipClick={(m) => {
                    setOpenTipPlaylistMusic(true);
                    setMusicId(m["topTipperId"]);
                    setMusicArtist(m["topTipperName"]);
                  }}
                  toggleMenu={(action, id, index) => {
                    toggleMenu(action, id, index);
                  }}
                  play={(index) => playAll(index, music)}
                  // play={(index) => play(index, music)}
                  sort={true}
                />
              ) : null}
            </Box>
          ) : (
            <NoData
              lable={title ? t("noData.message13") : t("noData.message14")}
            />
          )}
        </Box>
      </Box>
      {chatOpen ? (
        <Chat
          title={title}
          playListId={playListId}
          onOutsideClick={() => {
            setChatCount(null);
            setChatOpen(false);
          }}
          songs={music}
        />
      ) : null}
      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          isAlbum={isAlbum}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {openPopup ? (
        <ConfirmMusicNft
          open={openPopup}
          handleClose={(e, currency, units, platform) =>
            !e
              ? setOpenPopup(false)
              : createNft(selectedId, currency, units, platform)
          }
        />
      ) : null}
      {showSuccess ? (
        <SuccessPopup
          open={showSuccess}
          handleClose={() => setShowSuccess(false)}
          message={t("success.message5")}
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={title}
          id={playListId}
          open={openTip}
          isPlaylist={true}
          handleClose={handleClose}
        />
      ) : null}
      {openTipPlaylistMusic ? (
        <TipPopup
          artist={musicArtist}
          id={musicId}
          open={openTipPlaylistMusic}
          isArtist={true}
          handleClose={handleCloseTip}
        />
      ) : null}
      {isStreamingPopup ? (
        // <StreamingDetailPoup
        //   channelName={playListId}
        //   open={isStreamingPopup}
        //   handleClose={(open, goalTitle, goal, goalDescription, isNew, obs) =>
        //     open
        //       ? (dispatch(
        //           startStream({
        //             streamData: {
        //               title: title,
        //               _id: playListId,
        //               owner: owner,
        //               shareUrl: playlistData.shareUrl.livestreamShortLink,
        //             },
        //             title: goalTitle,
        //             goal: goal,
        //             isNew: isNew,
        //             goalDescription: goalDescription,
        //             obs: obs,
        //           })
        //         ),
        //         dispatch(start({ index: -1, songs: music, pos: -1 })),
        //         setIsStreamingPopup(false))
        //       : setIsStreamingPopup(false)
        //   }
        // />
        <StreamingDetailPoup
          channelName={playListId}
          open={isStreamingPopup}
          handleClose={(open, goalTitle, goal, goalDescription, isNew, obs) => {
            // console.log("OBS", obs);
            // console.log("isNew", isNew);
            if (open) {
              dispatch(
                startStream({
                  streamData: {
                    title: title,
                    _id: playListId,
                    owner: owner,
                    shareUrl: playlistData.shareUrl.livestreamShortLink,
                  },
                  title: goalTitle,
                  goal: goal,
                  isNew: isNew,
                  goalDescription: goalDescription,
                  obs: obs,
                })
              );
              dispatch(start({ index: -1, songs: music, pos: -1 }));
            }
            setIsStreamingPopup(false);
          }}
        />
      ) : null}
    </Box>
  );
}
